import FaqContact from '@propertypal/web-ui/src/faq/FaqContact';
import FaqPageContainer from '@propertypal/web-ui/src/faq/FaqPageContainer';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';
import { requireAuthToken } from '../../../utils/auth';

export const getServerSideProps: GetServerSideProps = requireAuthToken(async () => {
  return {
    props: {
      disableHeader: true,
      disableFooter: true,
    },
  };
});

const FaqContactPage: React.FC = () => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `FAQ Contact - PropertyPal`,
          url: `/faq/agent-faq/contact`,
        })}
      </Head>

      <FaqPageContainer
        hideContact
        breadcrumbs={[{ title: 'Home', url: '/' }, { title: 'Agent Faq', url: '/faq/agent-faq' }, { title: 'Contact' }]}
        agent
      >
        <FaqContact agent />
      </FaqPageContainer>
    </>
  );
};

export default FaqContactPage;
